import React from 'react';
import { CommentForm as BaseCommentForm } from '@producer/ui-kit';

import { CommentInput } from './comment-input';

import type { CommentFormProps } from '@producer/ui-kit';

type WebappCommentFormProps = Omit<CommentFormProps, 'renderInput'>;

/** The shared reply/edit editor, with the webapp's mentions and formatting toolbar in it. */
export const CommentForm: React.FC<WebappCommentFormProps> = (props) => (
  <BaseCommentForm {...props} renderInput={(inputProps) => <CommentInput {...inputProps} />} />
);
